(function () {
  var storageKeyPrefix = 'cv_recently_viewed_products';
  var maxStored = 16;

  function normalizeGame(game) {
    return /^[a-z0-9_-]+$/.test(game || '') ? game : '';
  }

  function getStorageKey(game) {
    game = normalizeGame(game);
    return game ? storageKeyPrefix + '_' + game : '';
  }

  function readHandles(storageKey) {
    if (!storageKey) return [];
    try {
      var raw = window.localStorage.getItem(storageKey);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeHandles(storageKey, handles) {
    if (!storageKey) return;
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, maxStored)));
    } catch (error) {
      return;
    }
  }

  function recordCurrentProduct() {
    var productInfo = document.querySelector('[data-product-handle]');
    if (!productInfo) return;

    var handle = productInfo.getAttribute('data-product-handle');
    var game = productInfo.getAttribute('data-product-game') || '';
    var storageKey = getStorageKey(game);
    if (!handle) return;

    var handles = readHandles(storageKey).filter(function (item) {
      return item && item !== handle;
    });
    handles.unshift(handle);
    writeHandles(storageKey, handles);
  }

  function formatYen(cents) {
    return Math.round((cents || 0) / 100).toLocaleString('ja-JP') + '円～';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function placeholderSvg() {
    return '<svg class="placeholder-svg" viewBox="0 0 100 100" aria-hidden="true"><rect width="100" height="100" fill="#eef3fb"></rect></svg>';
  }

  function getProductUrl(product) {
    return product.url || '/products/' + product.handle;
  }

  function getSafeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return /^https?:$/.test(url.protocol) ? url.toString() : '';
    } catch (error) {
      return '';
    }
  }

  function buildItem(product) {
    var item = document.createElement('li');
    item.className = 'cv-recently-viewed__item';
    var productUrl = getProductUrl(product);
    var title = product.title || '';

    var article = document.createElement('article');
    article.className = 'cv-recently-viewed-card';

    var link = document.createElement('a');
    link.href = getSafeUrl(productUrl);
    link.className = 'cv-recently-viewed-card__image-link';
    link.setAttribute('aria-label', title);

    var imageWrap = document.createElement('div');
    imageWrap.className = 'cv-recently-viewed-card__image-wrap';

    if (product.featured_image) {
      var image = document.createElement('img');
      image.src = getSafeUrl(product.featured_image);
      image.alt = title;
      image.loading = 'lazy';
      imageWrap.appendChild(image);
    } else {
      imageWrap.innerHTML = placeholderSvg();
    }

    link.appendChild(imageWrap);
    article.appendChild(link);
    item.appendChild(article);

    return item;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load product');
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function setEmptyState(section, isEmpty) {
    var list = section.querySelector('.cv-recently-viewed__list');
    var empty = section.querySelector('.cv-recently-viewed__empty');
    if (!list || !empty) return;

    empty.hidden = !isEmpty;
    list.hidden = isEmpty;
  }

  function renderSection(section) {
    var list = section.querySelector('.cv-recently-viewed__list');
    if (!list) return;

    var currentHandle = section.getAttribute('data-current-product-handle') || '';
    var game = section.getAttribute('data-game') || '';
    var storageKey = getStorageKey(game);
    var limit = Number(section.getAttribute('data-limit') || '4');
    var handlesSeen = {};
    var handles = readHandles(storageKey).filter(function (handle) {
      if (!handle || handle === currentHandle || handlesSeen[handle]) return false;
      handlesSeen[handle] = true;
      return true;
    });

    if (!handles.length) {
      setEmptyState(section, true);
      return;
    }

    Promise.all(
      handles.slice(0, limit).map(function (handle) {
        return fetchProduct(handle);
      })
    ).then(function (products) {
      var validProducts = products.filter(Boolean);
      if (!validProducts.length) {
        setEmptyState(section, true);
        return;
      }

      list.innerHTML = '';
      validProducts.forEach(function (product) {
        list.appendChild(buildItem(product));
      });
      setEmptyState(section, false);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    recordCurrentProduct();

    document.querySelectorAll('[data-recently-viewed-products]').forEach(function (section) {
      renderSection(section);
    });
  });
})();
